var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1525 855",
    width: 1525,
    height: 855,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DoorDash_Logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ff3008 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1093.6 854.9h-238.6c-7.3 0-14.6-0.7-21.7-2.1-7.2-1.4-14.2-3.5-20.9-6.3-6.8-2.7-13.3-6.2-19.3-10.2-6.1-4-11.8-8.6-17-13.8l-236.5-234.8c-2.6-2.6-4.8-5.5-6.5-8.7-1.7-3.2-3-6.6-3.7-10.1-0.7-3.6-0.9-7.2-0.5-10.9 0.4-3.6 1.3-7.1 2.7-10.4 1.4-3.4 3.3-6.5 5.6-9.3 2.3-2.8 5.1-5.3 8.1-7.3 3.1-2 6.4-3.6 9.9-4.6 3.5-1.1 7.1-1.6 10.7-1.6h527.5c54.5-0.6 98.2-44.6 97.6-98.4-0.5-53.8-45.1-97-99.6-96.4h-765.1c-29.6 0-58-11.6-78.9-32.4l-236.4-234.7c-2.6-2.5-4.7-5.4-6.5-8.6-1.7-3.2-2.9-6.6-3.6-10.2-0.7-3.5-0.9-7.1-0.6-10.7 0.4-3.6 1.3-7.2 2.7-10.5 1.4-3.4 3.3-6.5 5.6-9.3 2.3-2.8 5-5.3 8.1-7.3 3-2 6.3-3.6 9.8-4.7 3.5-1 7.1-1.6 10.7-1.6h1085.3c143.4-0.5 275.3 77.3 342.7 202.3 173.4 325.1-61.3 652.6-371.6 652.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/DASH.91e4c4be844e5d5a33d7eaa367e1182a.svg";
export { ForwardRef as ReactComponent };